<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;">
            <span class="text-muted fw-light">Vendors /</span> Vendor Details
        </h4>

        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <mat-icon class="nav-icon">tables</mat-icon>{{this.vendorId}} &nbsp;
                <!-- <div class="account">
                    <div [ngStyle]="{'color':this.primaryForm.valid && this.bankForm.valid && this.secondaryForm.valid? 'green' : 'red' }">
                        {{this.primaryForm.valid && this.bankForm.valid && this.secondaryForm.valid ?'(Active)':'(Not verified)'}}
                    </div>
                </div> -->
                <div class="account">
                    <div *ngIf="this.primaryForm.valid && this.bankForm.valid && this.secondaryForm.valid">
                        <img src="../../../assets/images/green.png" style="width: 20px;">
                    </div>
                    <div *ngIf="this.primaryForm.invalid || this.bankForm.invalid || this.secondaryForm.invalid">
                        <p style="color: red;">(Not verified)</p>
                    </div>
                </div>
                <div style=" display: flex;position: absolute;right: 20px;">
                    <mat-slide-toggle color="primary" [checked]="this.IsVendorActive" [disabled]="!primaryForm.valid || !secondaryForm.valid || !bankForm.valid" (change)="vendorToggle()">
                    </mat-slide-toggle>
                </div>
                <!-- {{this.IsVendorActive}} -->
            </mat-card-header>
            <!-- {{this.bankForm.value.IsVendorActive}} -->
            <mat-card-content>
                <div class="row ">
                    <div class="col-md-4">
                        <mat-card class="mt-5">
                            <mat-card-content style=" margin: 15px; font-size: 16px; text-align: center;">
                                Primary Details &nbsp; <a href="#primary"><i class="fa fa-pencil"></i></a>
                                <div class="account" style="padding: 30px;text-align: center;">
                                    <div [ngStyle]="{'color':this.primaryForm.valid ? 'green' : 'red' }">
                                        {{this.primaryForm.valid ?'Completed':'Not Completed'}}
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div class="col-md-4">
                        <mat-card class="mt-5">
                            <mat-card-content style=" margin: 15px; font-size: 16px; text-align: center;">
                                Bank Details &nbsp; <a href="#bank"><i class="fa fa-pencil"></i></a>
                                <div class="account" style="padding: 30px;text-align: center;">
                                    <div [ngStyle]="{'color':this.bankForm.valid ? 'green' : 'red' }">
                                        {{this.bankForm.valid ?'Completed':'Not Completed'}}
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>

                    <div class="col-md-4">
                        <mat-card class="mt-5">
                            <mat-card-content style=" margin: 15px; font-size: 16px; text-align: center;">
                                Secondary Details &nbsp; <a href="#secondary"><i class="fa fa-pencil"></i></a>
                                <div class="account" style="padding: 30px;text-align: center;">
                                    <div [ngStyle]="{'color':this.secondaryForm.valid ? 'green' : 'red' }">
                                        {{this.secondaryForm.valid ?'Completed':'Not Completed'}}
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>


        <div id="primary"></div>
        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <mat-icon class="nav-icon">person</mat-icon>Primary Details &nbsp;
            </mat-card-header>
            <mat-card-content class="mt-4">
                <form [formGroup]="primaryForm" (ngSubmit)="onPrimarySubmit()">
                    <mat-grid-list cols="4" rowHeight="120px">
                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>First Name</mat-label>
                                    <input matInput formControlName="companyName" name="companyName" id="companyName" (change)="onFieldChange('fm')" required
                                        [ngClass]="{'is-invalid':submitted && primaryForms.vendorId.errors}" autofocus>

                                    <mat-error *ngIf="submitted && primaryForms.companyName.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="primaryForms.companyName.errors.required">VendorId is required
                                        </div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>

                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Last Name</mat-label>
                                    <input matInput formControlName="lastName"
                                        [ngClass]="{'is-invalid':submitted && primaryForms.lastName.errors}" (change)="onFieldChange('lm')" required>
                                    <mat-error
                                        *ngIf="submitted && primaryForms.lastName.errors && primaryForms.lastName.touched"
                                        class="invalid-feedback">
                                        <div *ngIf="primaryForms.lastName.errors.required"> This field is required
                                        </div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>

                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email" required
                                        [ngClass]="{'is-invalid':submitted && primaryForms.email.errors}" (change)="onFieldChange('email')" autofocus>

                                    <mat-error
                                        *ngIf="submitted && primaryForms.email.errors && primaryForms.email.touched"
                                        class="invalid-feedback">
                                        <div *ngIf="primaryForms.email.errors.required">Email is required</div>
                                        <div *ngIf="primaryForms.email.errors.email">Email must be a valid email
                                            address
                                        </div>
                                        <div *ngIf="primaryForms.email.errors.pattern">The Email is not valid email
                                            address</div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>

                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Phone Number</mat-label>
                                    <input matInput formControlName="phone" (keypress)="onPressPrimary($event)"
                                        placeholder="XXX-XXX-XXXX"
                                        [ngClass]="{'is-invalid':submitted && primaryForms.phone.errors}" required
                                        autocomplete="doNotAutoComplete" (change)="onFieldChange('phone')"  appPhoneMask appNumericOnly>
                                    <mat-error
                                        *ngIf="submitted && primaryForms.phone.errors && primaryForms.phone.touched"
                                        class="invalid-feedback">
                                        <div *ngIf="primaryForms.phone.errors.required">Phone Number is required
                                        </div>
                                        <div *ngIf="primaryForms.phone.errors.pattern">Please, Enter 10 digit Mobile
                                            Number</div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>
                    </mat-grid-list>

                    <mat-card-actions>
                        <div class="buttonRow">
                            <button mat-raised-button type="submit" class="button" [disabled]="isLoad">
                                <!-- <mat-icon class="icons" *ngIf="status==false">edit </mat-icon> -->
                                <span class="material-symbols-outlined" *ngIf="status==false">
                                    edit
                                </span>
                                <mat-icon class="icons" *ngIf="status==true" style="margin-right: 30px;">save</mat-icon>
                                {{status==false ? 'Edit' :'Save Changes' }}
                            </button>
                            <button mat-raised-button *ngIf="status" (click)="resetPri()" class="buttonReset">
                                Cancel</button>
                        </div>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>

        <div id="bank"></div>
        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <mat-icon class="nav-icon">apartment</mat-icon>Bank Details &nbsp;
            </mat-card-header>
            <mat-card-content class="mt-4">
                <form [formGroup]="bankForm" (ngSubmit)="onBankSubmit()">
                    <mat-grid-list cols="4" rowHeight="250px">
                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Routing Number</mat-label>
                                    <input matInput formControlName="bankRoutingNumber"
                                        (keypress)="routingNumValidations($event)" (mouseout)="routingNum()" (change)="onFieldChange('rn')"
                                        OnlynumberDirective
                                        [ngClass]="{'is-invalid' : submitted && bankForms.bankRoutingNumber.errors}"
                                        required>
                                    <mat-error *ngIf="submitted && bankForms.bankRoutingNumber.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="bankForms.bankRoutingNumber.errors.required"> This feild is required
                                        </div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Tax ID Number</mat-label>
                                    <input matInput formControlName="companyTaxId" required (change)="onFieldChange('ctid')"
                                        [ngClass]="{'is-invalid' : submitted && bankForms.companyTaxId.errors}">
                                    <mat-error *ngIf="submitted && bankForms.companyTaxId.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="bankForms.companyTaxId.errors.required"> This feild is required
                                        </div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Zip Code</mat-label>
                                    <input matInput formControlName="zip" OnlynumberDirective
                                        [ngClass]="{'is-invalid':submitted && bankForms.zip.errors}"
                                        (input)="onFieldChange('zip');onZipCodeChange($event)" required>
                                    <mat-error *ngIf="submitted  && bankForms.zip.errors" class="invalid-feedback">
                                        <div *ngIf="bankForms.zip.errors.required">ZipCode is required</div>
                                        <div *ngIf="bankForms.zip.errors.minlength">Mininmum length is 5</div>
                                        <div *ngIf="bankForms.zip.errors.maxlength">Maximum length is 5</div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>

                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Bank Name</mat-label>
                                    <input matInput type="text" formControlName="nameOfBank" name="nameOfBank"
                                           (change)="onFieldChange('bn')" required
                                        id="nameOfBank"
                                        [ngClass]="{'is-invalid':submitted && bankForms.nameOfBank.errors}">
                                    <mat-error *ngIf="submitted && bankForms.nameOfBank.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="bankForms.nameOfBank.errors.required">This feild is required </div>
                                    </mat-error>
                                </mat-form-field>


                                <mat-form-field appearance="outline">
                                    <mat-label>Bank Address</mat-label>
                                    <input matInput formControlName="bankAddress" (change)="onFieldChange('bAdd')"
                                        [ngClass]="{'is-invalid' : submitted && bankForms.bankAddress.errors}" required>
                                    <mat-error *ngIf="submitted && bankForms.bankAddress.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="bankForms.bankAddress.errors.required"> This feild is required
                                        </div>
                                    </mat-error>
                                </mat-form-field>

                                <!-- <mat-form-field appearance="outline">
                                    <mat-label>Country</mat-label>
                                    <input matInput formControlName="country"
                                        [ngClass]="{'is-invalid':submitted && bankForms.country.errors}" required>
                                    <mat-error *ngIf="submitted && bankForms.country.errors" class="invalid-feedback">
                                        <div *ngIf="bankForms.country.errors.required"> This feild is required </div>
                                    </mat-error>
                                </mat-form-field> -->
                                <mat-form-field appearance="outline">
                                    <mat-label>State</mat-label>
                                    <!-- <input matInput formControlName="state"
                                        [ngClass]="{'is-invalid' : submitted && bankForms.state.errors}" required> -->
                                    <mat-select formControlName="state" name="state" id="state"
                                        (selectionChange)="onStateClick($event);onFieldChange('state')"
                                        [ngClass]="{'is-invalid':submitted && bankForms.state.errors}" required>
                                        <mat-option *ngFor="let State of states" [value]="State.stateId">
                                            {{ State.state }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="submitted && bankForms.state.errors" class="invalid-feedback">
                                        <div *ngIf="bankForms.state.errors.required"> This field is required
                                        </div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>

                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Account Number</mat-label>
                                    <input matInput formControlName="accountNumber" OnlynumberDirective (change)="onFieldChange('an')"
                                        [ngClass]="{'is-invalid' : submitted && bankForms.accountNumber.errors}"
                                        required>
                                    <mat-error *ngIf="submitted && bankForms.accountNumber.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="bankForms.accountNumber.errors.required"> This feild is required
                                        </div>
                                    </mat-error>
                                </mat-form-field>
                                
                                
                                <mat-form-field appearance="outline">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="paymentEmailAddress" (change)="onFieldChange('pea')"
                                        [ngClass]="{'is-invalid' : submitted && bankForms.paymentEmailAddress.errors}"
                                        required>
                                    <mat-error *ngIf="submitted && bankForms.paymentEmailAddress.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="bankForms.paymentEmailAddress.errors.required"> This feild is
                                            required
                                        </div>
                                        <!-- <div *ngIf="bankForms.paymentEmailAddress.errors.email">Email must be a valid
                                            email
                                            address</div> -->
                                        <div *ngIf="bankForms.paymentEmailAddress.errors.pattern">Email must be a valid
                                            email address
                                        </div>
                                    </mat-error>
                                </mat-form-field>
                                <!-- JSON:{{states | json }} -->

                                <mat-form-field appearance="outline">
                                    <mat-label>City</mat-label>
                                    <!-- <input matInput formControlName="city"
                                        [ngClass]="{'is-invalid' : submitted && bankForms.city.errors}" required> -->
                                    <mat-select formControlName="city" name="city" id="city" required (selectionChange)="onFieldChange('city')"
                                        [ngClass]="{'is-invalid':submitted && bankForms.city.errors } ">
                                        <mat-option *ngFor="let City of cities" [value]="City">
                                            {{ City }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="submitted && bankForms.city.errors" class="invalid-feedback">
                                        <div *ngIf="bankForms.city.errors.required"> This feild is required</div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>

                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Confirm Account Number</mat-label>
                                    <input matInput type="password"  formControlName="ConfirmAccNum" id="ConfirmAccNum"
                                        name="ConfirmAccNum" 
                                        [ngClass]="{'is-invalid' : submitted && bankForms.ConfirmAccNum.errors}" required  OnlynumberDirective>
                                    <mat-error *ngIf="submitted && bankForms.ConfirmAccNum.errors" class="invalid-feedback">
                                        <div *ngIf="bankForms.ConfirmAccNum.errors.required"> This field is required</div>
                                    </mat-error>
                                </mat-form-field>
                                
                                <mat-form-field appearance="outline">
                                    <mat-label>Account Type</mat-label>
                                    <input matInput formControlName="accountType"
                                        [ngClass]="{'is-invalid' : submitted && bankForms.accountType.errors}"  (change)="onFieldChange('acntType')"required>
                                    <mat-error *ngIf="submitted && bankForms.accountType.errors "
                                        class="invalid-feedback">
                                        <div *ngIf="bankForms.accountType.errors.required"> This feild is required</div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Phone Number</mat-label>
                                    <input matInput formControlName="bankContact" (keypress)="onPressBank($event)" (change)="onFieldChange('bContact')"
                                        placeholder="XXX-XXX-XXXX"
                                        [ngClass]="{'is-invalid':submitted && bankForms.bankContact.errors}" required
                                        autocomplete="doNotAutoComplete" appPhoneMask appNumericOnly>
                                    <mat-error *ngIf="submitted && bankForms.bankContact.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="bankForms.bankContact.errors.required">Phone Number is required
                                        </div>
                                        <div *ngIf="bankForms.bankContact.errors.pattern">Please, Enter 10 digit Mobile
                                            Number</div>
                                    </mat-error>
                                </mat-form-field>
                               
                                <!-- <mat-form-field appearance="outline" style="visibility: hidden;">
                                    <mat-label>City</mat-label>
                                    <input matInput>
                                </mat-form-field> -->
                            </div>
                        </mat-grid-tile>
                    </mat-grid-list>

                    <mat-card-actions>
                        <div class="buttonRow">
                            <button mat-raised-button type="submit" class="button" [disabled]="isBankLoad">
                                <!-- <mat-icon class="icons" *ngIf="statusBank==false">edit </mat-icon> -->
                                <span class="material-symbols-outlined" *ngIf="statusBank==false">
                                    edit
                                </span>
                                <mat-icon class="icons" *ngIf="statusBank==true"
                                    style="margin-right: 30px;">save</mat-icon>
                                {{statusBank==false ? 'Edit' :'Save Changes' }}
                            </button>
                            <button mat-raised-button *ngIf="statusBank" (click)="resetBank()" class="buttonReset">
                                Cancel</button>
                        </div>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>

        <div id="secondary"></div>
        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <mat-icon class="nav-icon">person</mat-icon>Secondary Details &nbsp;
            </mat-card-header>
            <mat-card-content class="mt-4">
                <form [formGroup]="secondaryForm" (ngSubmit)="onSecondarySubmit()">
                    <mat-grid-list cols="4" rowHeight="100px">
                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Secondary Contact</mat-label>
                                    <input matInput formControlName="secondaryCompanyContact" (change)="onFieldChange('sContact')"
                                        [ngClass]="{'is-invalid':submitted && secForms.secondaryCompanyContact.errors}"
                                        required>
                                    <mat-error *ngIf="submitted && secForms.secondaryCompanyContact.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="secForms.secondaryCompanyContact.errors.required">Secondary Contact
                                            is
                                            required
                                        </div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>

                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Phone Number</mat-label>
                                    <input matInput formControlName="secondaryPhone" (keypress)="onPressSec($event)"
                                        placeholder="XXX-XXX-XXXX" (change)="onFieldChange('sPhone')"
                                        [ngClass]="{'is-invalid':submitted && secForms.secondaryPhone.errors}" required
                                        autocomplete="doNotAutoComplete" appPhoneMask appNumericOnly>
                                    <mat-error *ngIf="submitted && secForms.secondaryPhone.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="secForms.secondaryPhone.errors.required">Phone Number is required
                                        </div>
                                        <div *ngIf="secForms.secondaryPhone.errors.pattern">Please, Enter 10 digit
                                            Mobile
                                            Number</div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>

                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>E-mail</mat-label>
                                    <input matInput formControlName="secondaryEmail" (change)="onFieldChange('sEmail')"
                                        [ngClass]="{'is-invalid' : submitted && secForms.secondaryEmail.errors}"
                                        required>
                                    <mat-error *ngIf="submitted && secForms.secondaryEmail.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="secForms.secondaryEmail.errors.required"> This feild is required
                                        </div>
                                        <div *ngIf="secForms.secondaryEmail.errors.email">Email must be a valid email
                                            address</div>
                                        <div *ngIf="secForms.secondaryEmail.errors.pattern">The Email is not valid
                                            email address
                                        </div>
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>

                        <mat-grid-tile>
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Other Details(If Any)</mat-label>
                                    <input matInput formControlName="secondaryOtherDetail" (change)="onFieldChange('sOtherDet')">
                                    <!-- [ngClass]="{'is-invalid':submitted && secForms.secondaryOtherDetail.errors}"
                                        required>
                                    <mat-error *ngIf="submitted && secForms.secondaryOtherDetail.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="secForms.secondaryOtherDetail.errors.required">Secondary Contact is
                                            required
                                        </div>
                                    </mat-error> -->
                                </mat-form-field>
                            </div>
                        </mat-grid-tile>
                    </mat-grid-list>

                    <mat-card-actions>
                        <div class="buttonRow">
                            <button mat-raised-button type="submit" class="button" [disabled]="isSecLoad">
                                <!-- <mat-icon class="icons" *ngIf="statusSec==false">edit
                                </mat-icon> -->
                                <span class="material-symbols-outlined" *ngIf="statusSec==false">
                                    edit
                                </span>
                                <mat-icon class="icons" *ngIf="statusSec==true"
                                    style="margin-right: 30px;">save</mat-icon>
                                {{statusSec==false ? 'Edit' :'Save Changes' }}
                            </button>
                            <button mat-raised-button *ngIf="statusSec" (click)="resetSec()" class="buttonReset">
                                Cancel</button>
                        </div>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>

        <mat-card class="mt-3">
            <mat-card-header class="mt-3">
                <mat-icon class="nav-icon">description</mat-icon>Vendor Documents &nbsp;
            </mat-card-header>
            <mat-card-content class="mt-4">
                <form [formGroup]="fileForm">
                    <div class="file">
                        <label for="formFile" class="form-label">Upload file</label>
                        <input (change)="this.onFilechange($event)" class="form-control" type="file" id="documentName"
                            name="documentName" #fileInput multiple="multiple" required>
                        <button (click)="uploadVendorDoc()" type="button" class="btn btn-primary mt-3">Upload</button>
                    </div>

                    <div class="tab-content mt-3">
                        <div class="tab-pane fade show active" id="navs-pills-justified-tablesuccess" role="tabpanel">
                            <div class="card">
                                <table mat-table [dataSource]="dataSource" matSort #empTbSort="matSort"
                                    (matSortChange)="announceSortChange($event)" class="mat-elevation-z8">
                                    <ng-container matColumnDef="documentName">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by documentName" class="heading"
                                            [resizeColumn]="true" [index]="0">File Name</th>
                                        <td mat-cell *matCellDef="let element"> <a
                                                [href]="createURL(element.documentName,element.documentPath)">
                                                {{element.documentName}}</a>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="w9VerifiedYear">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by w9VerifiedYear" [resizeColumn]="true"
                                            [index]="1">Year Verified</th>
                                        <td mat-cell *matCellDef="let element">
                                            <mat-form-field appearance="outline" class="mt-3">
                                                <mat-label>Select year</mat-label>
                                                <mat-select (selectionChange)="onYearChange($event,element)"
                                                    [value]="element.w9VerifiedYear">
                                                    <mat-option *ngFor="let year of years" [value]="year?.toString()">{{
                                                        year }}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="typeOfDoc">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by typeOfDoc" class="heading"
                                            [resizeColumn]="true" [index]="2">Document Type</th>
                                        <td mat-cell *matCellDef="let element">
                                            <mat-form-field appearance="outline" class="mt-3">
                                                <mat-label>Select type</mat-label>
                                                <mat-select matNativeControl
                                                    (selectionChange)="onTypeChange($event,element)"
                                                    [value]="element.typeOfDoc">
                                                    <mat-option value="W-9">W-9</mat-option>
                                                    <mat-option value="ACH/eCheck form">ACH/eCheck form</mat-option>
                                                    <mat-option value="Other">Other</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="createdDate">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by createdDate" class="heading"
                                            [resizeColumn]="true" [index]="3">Uploaded</th>
                                        <td mat-cell *matCellDef="let element">
                                            <div *ngIf="element.modifiedDate==null">{{element.formattedCreatedDate}}
                                            </div>
                                            <div *ngIf="element.modifiedDate!=null">{{element.modifiedDate |
                                                date:'M/d/yyy'}}
                                            </div>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="Edit">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                                            sortActionDescription="Sort by save" class="heading" [resizeColumn]="true"
                                            [index]="4">Save</th>
                                        <td mat-cell *matCellDef="let element">
                                            <button type="button" class="btn btn-primary"
                                                (click)="updateVendorDoc(element)">Save</button>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                    <!-- <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"
                                    </td>
                                </tr> -->
                                </table>
                            </div>
                        </div>
                    </div>
                    <mat-card-actions>
                        <div class="text-align mt-3">
                            <mat-paginator #myPaginator [length]="25" [pageSize]="3"
                                [pageSizeOptions]="[3, 10, 25, 100]">
                            </mat-paginator>
                        </div>
                    </mat-card-actions>
                    <alert class="notification"></alert>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>

<div id="loadingspinner" *ngIf="isLoading">
    <div class="spinner">
        <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
    </div>
</div>
